import UnderDevelopment from '../templates/UnderDevelopment.vue'

// Scan amd import Import all Vue views dynamically 
const views = import.meta.glob('../apps/**/*.vue')

//  Mapping menu route path to dynamic view components
    function resolveComponent(routePath) {
        // Normalize path string (e.g., "/uikit/formlayout" -> "uikit/formlayout")
        const cleanPath = routePath.replace(/^\//, '').toLowerCase()
        
        // Look for matching files in templates
        const possiblePaths = [
            `../apps/${cleanPath}.vue`,
            `../apps/${cleanPath}/Index.vue`,
            `../apps/modules/${cleanPath}.vue`
        ]
    
        for (const path of possiblePaths) {
            if (views[path]) {
                return views[path]
            }
        }
    
        // Fallback view if component file doesn't exist yet
        return UnderDevelopment
    }


// Recursively register dynamic child routes under MainLayout
export function registerMenuRoutes(router, menuItems) {
    const registerItem = (item) => {
      if (item.to && !item.to.startsWith('http')) {
        // Ensure path always starts with "/"
        const routePath = item.to.startsWith('/') ? item.to : `/${item.to}`
        
        // const relativePath = routePath.substring(1)!

        // Ignoring route for redirect to main panel ( Right Panel ) !!
        const isAuthRoute = routePath.toLowerCase().includes('login') 
                        ||  routePath.toLowerCase().includes('logout')
                        ||  routePath.toLowerCase().includes('register')
                        ||  routePath.toLowerCase().includes('forgot-pass')

        // Check if route is already registered
        const exists = router.getRoutes().some(r => r.path === routePath)

        // if (!exists && relativePath !== '' && !isAuthRoute) {
        if (!exists && !isAuthRoute ) {
            router.addRoute('MainLayout', {
                path     : routePath,                     // Must start with "/"
                name     : item.label,
                component: resolveComponent(routePath),
                meta     : { title: item.label }
            })
        }
      }
  
        // Recursively handle nested submenus
        if (item.items && Array.isArray(item.items)) {
            item.items.forEach(registerItem)
        }
    }
  
    menuItems.forEach(registerItem)
  }